// extracted by mini-css-extract-plugin
module.exports = {"root":"Table_root__1tJjV","head":"Table_head__2WjaF","col":"Table_col__2YB-v"};